import { z } from 'zod';

import { messages } from './messages';
import { urlRegex } from './regex';

export const select = {
    string: z.string().nullish(),
    number: z.number().nullish(),
    enum: <T extends z.EnumLike>(nativeEnum: T) => z.nativeEnum(nativeEnum).nullish(),
};

export const multiSelect = {
    string: z.array(z.string()).nullish(),
    number: z.array(z.number()).nullish(),
};

export const textField = {
    string: z.string().trim().nullish(),
    email: (max?: number) => {
        let emailRule = z.string().trim().email();

        if (max) {
            emailRule = emailRule.max(max);
        }

        /**
         * Email validator mark empty string is invalid
         * As it's optional we need to handle empty string as valid value
         */
        return z.union([z.literal(''), emailRule.nullish()]);
    },
    url: z.union([z.literal(''), z.string().trim().url()]),
    urlWithOptionalProtocol: z
        .string()
        .nullish()
        .refine((val) => !val || urlRegex.test(val), messages.invalidUrl),
};

export const numberField = {
    number: z.number().nullish(),
};
